module.exports = __webpack_public_path__ + "img/play-circle.ad54d247.svg";